import React from 'react';

export function ArrowUpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
    >
      <path
        d="M8.54898 1.07785C8.24228 0.752045 7.74501 0.752046 7.43831 1.07785L0.230028 8.73501C-0.0766759 9.06082 -0.0766759 9.58905 0.230028 9.91485C0.536732 10.2407 1.034 10.2407 1.3407 9.91485L7.99918 2.84172L14.666 9.92369C14.9712 10.2479 15.4659 10.2479 15.7711 9.92369C16.0763 9.59952 16.0763 9.07392 15.7711 8.74974L8.54898 1.07785Z"
        fill="#008254"
      />
    </svg>
  );
}
